import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import CenteredModal from "components/common/modals/CenteredModal";

function RemoveModal({ show, handleClick, setShow, header }) {
  const content = (
    <Container>
      <Row>
        <Col className="my-4 mt-lg-5">
          <Row>
            <Col sm={12} className="mb-4 text-center text-lg-start">
              <h3 className="text-center">{header}</h3>
            </Col>
            <Col sm={6} className="mb-4 order-1 order-lg-2">
              <Button className="w-100 btn-danger" onClick={handleClick}>
                Delete
              </Button>
            </Col>
            <Col sm={6} className="order-2 order-lg-1">
              <Button
                onClick={() => setShow(false)}
                className="w-100 btn-primary-outline"
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );

  return <CenteredModal bodyContent={content} show={show} setShow={setShow} />;
}

export default RemoveModal;
